import { forwardRef } from "react";
import styles from "./PhoneInput.module.css";

const sanitize = (raw) => {
  let digits = (raw || "").replace(/\D/g, "");
  while (digits.startsWith("0")) digits = digits.slice(1);
  return digits.slice(0, 9);
};

const PhoneInput = forwardRef(function PhoneInput(
  {
    value = "",
    onChange,
    name,
    error,
    placeholder = "997660042",
    disabled = false,
    onBlur,
    id,
    // "md" (default, ~44px) fits standard form modals; "lg" (~54px) matches
    // the larger splashy fields on the auth/register pages.
    size = "md",
  },
  ref
) {
  const handleChange = (e) => {
    const cleaned = sanitize(e.target.value);
    if (onChange) {
      onChange(cleaned);
    }
  };

  const sizeClass = size === "lg" ? styles.lg : styles.md;

  return (
    <div className={`${styles.wrapper} ${sizeClass}`}>
      <div className={styles.row}>
        <div className={styles.prefix}>(+994)</div>
        <input
          ref={ref}
          id={id}
          type="tel"
          inputMode="numeric"
          autoComplete="tel"
          maxLength={9}
          pattern="[1-9][0-9]{8}"
          name={name}
          value={value}
          onChange={handleChange}
          onBlur={onBlur}
          placeholder={placeholder}
          disabled={disabled}
          className={styles.input}
        />
      </div>
      {error && <p className={styles.error}>{error}</p>}
    </div>
  );
});

export default PhoneInput;
